import { Field, ErrorMessage } from 'formik';

export const FormInput = ({
  as = 'input',
  type = 'text',
  name,
  rows,
  className,
  minHeight,
  disabled = false,
  autoComplete = 'off',
}) => {
  return (
    <div className={className}>
      <Field
        as={as}
        type={type}
        name={name}
        id={name}
        rows={rows}
        disabled={disabled}
        autoComplete={autoComplete}
        className="border border-gray-100 rounded-md p-2 w-full"
        style={{ minHeight: minHeight }}
      />
      <ErrorMessage name={name} component="div" className="text-error-200" />
    </div>
  );
};
